import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";


const GetComplaintTrackingNull = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintTrackingManage/ComplaintTrackingNull",
    params
  );
};

const AddTrackingScreening = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintTrackingManage/AddTrackingScreening?userId=" +
    userData.userId(),
    params
  );
};


export {
    GetComplaintTrackingNull,
    AddTrackingScreening,
};
